import Banner from "../Allcomponent/Banner"
import Shirts from "../Allcomponent/shirts"
import Cards from "../Allcomponent/cards"
function Tshirts(){
    return(
        <>

        <Banner/>
         <Cards/>
        <Shirts/>
       
        </>
    )
}
export default Tshirts